import { Enums } from '@bode-canada/core';

export default class BusinessAccountHelper {
  static getUsersBusinessAccounts(users) {
    return users.map(({ userBusinessAccounts }) => userBusinessAccounts)
      .flat()
      .filter((account) => account);
  }

  static getIsUserBusinessPartner(
    userBusinessAccounts,
    targetBusinessAccounts,
    accountType = Enums.BusinessAccountTypeEnum.BUILDER,
  ) {
    const targetBuilderAccountIds = this.getUserAccountIdsByRoleAndType(
      targetBusinessAccounts,
      Enums.UserBusinessAccountRoleEnum.UNIT,
      accountType,
    );
    const userBuilderAccountIds = this.getUserAccountIdsByRoleAndType(
      userBusinessAccounts,
      Enums.UserBusinessAccountRoleEnum.MANAGER,
      accountType,
    );

    return userBuilderAccountIds.length
      && targetBuilderAccountIds.length
      && targetBuilderAccountIds.some((id) => userBuilderAccountIds.includes(id));
  }

  static getUserAccountIdsByRoleAndType(userAccounts, accountRole, accountType) {
    return (userAccounts || [])
      .filter((userAccount) => (
        userAccount.role === accountRole
        && userAccount.businessAccount.type === accountType
      ))
      .map(({ businessAccount }) => businessAccount.id);
  }

  static isUserBusinessAccountBuilderType(user) {
    if (user.userBusinessAccounts.length) {
      return user.userBusinessAccounts
        .some((account) => account.businessAccount.type === Enums.BusinessAccountTypeEnum.BUILDER);
    }

    return false;
  }
}
